import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@material-ui/core';
import React, { FC, useState } from 'react';
import Ticket from 'src/interfaces/api/Ticket';
import { createUseStyles } from 'src/theming';
import { Controller, useForm } from 'react-hook-form';

interface Props {
  open: boolean;
  onClose: () => void;
  onDunningTicket: (comment?: string) => Promise<Ticket>;
}

const useStyles = createUseStyles({
  formField: {
    marginTop: '15px !important',
  },
  error: {
    color: '#f44336',
  },
});

interface DunningForm {
  comment?: string;
}

const DunningTicketModal: FC<Props> = ({ open, onDunningTicket, onClose }) => {
  const [formError, setFormError] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);
  const { control, handleSubmit } = useForm<DunningForm>();

  const classes = useStyles();

  const onSubmit = async (data: DunningForm) => {
    try {
      setLoading(true);

      await onDunningTicket(data.comment);

      setLoading(false);
      setFormError(undefined);
      onClose();
    } catch (e) {
      setLoading(false);
      setFormError(e.message);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Relance ticket</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Vous pouvez ajouter un commentaire à la relance qui s'affichera sur le mur du ticket.
        </DialogContentText>

        <Controller
          name='comment'
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              label='Commentaire'
              variant='outlined'
              multiline
              minRows={3}
              fullWidth
              error={undefined !== error}
              helperText={error?.message}
            />
          )}
        />

        {formError && <p className={classes.error}>{formError}</p>}
      </DialogContent>

      <DialogActions>
        <Button type='button' onClick={onClose} color='primary'>
          Annuler
        </Button>

        <Button type='submit' onClick={handleSubmit(onSubmit)} color='primary'>
          {loading && <CircularProgress color='primary' size={15} />} Valider
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DunningTicketModal;
